import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import logo from "assets/img/logo_somos.svg";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import AlertInfo from "components/AlertInfo/AlertInfo.jsx";
import WaitDialog from "conten/components/WaitDialog.jsx";
import {
  ingresoInicioSolicitud,
  ingresoCompletarSolicitud,
} from "conten/ingresoSistema/IngresoSistemaActions";
import { addMessage } from "conten/mensajes/MessagesActions";
import {
  generarValoresDiff,
  encriptarContenido,
} from "conten/ingresoSistema/Autenticar";
import { OK, IS_LOGGED } from "config/general/Configuracion";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from 'jwt-decode';
import IngresoSistemaApi from "./IngresoSistemaApiClient";
import FormularioRegistroUsuario from "./FormularioRegistroUsuario";
import Dialog from "@material-ui/core/Dialog";
import IngresoSistemaApiHelper from "./IngresoSistemaApiHelper";
import InstallButton from "components/InstallButton/InstallButton";


const IngresoSistema = ({
  classes,
  ingresoSistemaState,
  ingresoInicioSolicitud,
  ingresoCompletarSolicitud,
  addMessage,
}) => {
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");
  const [cardAnimaton, setCardAnimaton] = useState("cardHidden");
  const [toAdmin, setToAdmin] = useState(false);
  const [openAlertInfo, setOpenAlertInfo] = useState(false);
  const [textAlertInfo, setTextAlertInfo] = useState("");
  const clientId = "628637621652-hrld326tq21vmmqjq4280b1p76r3t2nl.apps.googleusercontent.com";
  const [openModalRegistro, setOpenModalRegistro] = useState(false);
  const [datosGoogle, setDatosGoogle] = useState(null);
  const [tiposIdentificacionList, setTiposIdentificacionList] = useState([]);
  const cuenta = '210504082820861533'

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCardAnimaton("");
    }, 700);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Validar si ya hay sesión activa en localStorage
    const loggedIn = localStorage.getItem(IS_LOGGED);
    if (loggedIn === "true") {
      setToAdmin(true); // Redirigir al dashboard
    }
  }, []);



  const mostrarMensaje = (text, tipo = "error") => {
    addMessage({ variant: tipo, message: text });
  };

  if (toAdmin) return <Redirect to="/admin" />;

  const handleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const documentos = await IngresoSistemaApi.obtenerListaDocumentos(cuenta);
      const existeUsuario = await IngresoSistemaApi.verificarExistenciaUsuario(decoded.email, cuenta);

      if (existeUsuario) {
        // 🔐 Autenticación segura con Diffie-Hellman
        iniciarAutenticacionPorGoogle(decoded.email);
      } else {
        // 🧾 Mostrar modal o redireccionar a formulario de creación
        setTiposIdentificacionList(documentos)
        modalCrearUsuario(decoded); // Puedes pasar el objeto completo
      }

    } catch (error) {
      console.error("❌ Error al procesar autenticación con Google:", error);
    }
  };

  const handleError = () => {
    console.error("Fallo la autenticación con Google");
  };

  const modalCrearUsuario = (googleData) => {
    setDatosGoogle({
      correo: googleData.email,
      nombre1: googleData.given_name,
      apellido1: googleData.family_name,
      foto_perfil: googleData.picture
    });
    setOpenModalRegistro(true);
  };

  const handleRegistroUsuario = async (datosCompletos) => {

    try {
      const response = await IngresoSistemaApi.crearUsuario(cuenta, datosCompletos);
      // Axios: response.status
      if (response.id) {
        mostrarMensaje("Usuario creado exitosamente", "success");
        setOpenModalRegistro(false);
        iniciarAutenticacionPorGoogle(datosCompletos.correo);
      } else {
        mostrarMensaje("⚠️ Error al crear el usuario: " + (response.data?.mensaje || "Respuesta inesperada"));
      }
    } catch (error) {
      // Axios: error.response
      const msg =
        error?.response?.data?.mensaje ||
        error?.response?.data ||
        error.message ||
        "Error inesperado";

      mostrarMensaje("❌ " + msg);
    }
  };

  const iniciarAutenticacionPorGoogle = async (email) => {
    try {
      // 1. Solicitud inicial
      const respuesta = await new Promise((resolve) =>
        ingresoInicioSolicitud((estado, contenido) => resolve({ estado, contenido }))
      );

      const { estado, contenido } = respuesta;

      if (estado !== OK || !contenido?.p || !contenido?.g || !contenido?.b || !contenido?.idSolicitud) {
        mostrarMensaje("⚠️ Error al iniciar solicitud de autenticación: datos incompletos");
        return;
      }

      // 2. Generar Diffie-Hellman
      const { p, g, b, idSolicitud } = contenido;
      const diff = await generarValoresDiff(parseInt(p), parseInt(g), parseInt(b));
      const token = encriptarContenido(
        JSON.stringify({ usuario: email, clave: "OAuthGoogle2017*" }),
        diff.hash
      );

      // 3. Completar solicitud
      const resultadoFinal = await new Promise((resolve) =>
        ingresoCompletarSolicitud(idSolicitud, diff.A, token, (estado, datos) =>
          resolve({ estado, datos })
        )
      );

      if (resultadoFinal.estado === OK) {
        await IngresoSistemaApiHelper.obtenerInformacionUsuario();

        // Guardar sesión correctamente
        localStorage.setItem(IS_LOGGED, "true");
        localStorage.setItem("email", email);

        // Mostrar mensaje inmediatamente
        mostrarMensaje(`✅ Bienvenido ${email}`, "success");

        // Redirigir al dashboard
        setToAdmin(true);
      } else {
        mostrarMensaje("❌ Error al autenticar usuario de Google");
      }
    } catch (err) {
      console.error("❌ Error inesperado en autenticación por Google:", err);
      mostrarMensaje("❌ Error técnico durante la autenticación");
    }
  };

  return (
    <div className={classes.container} style={{ height: "100vh" }}>
      <InstallButton />
      <GridContainer justifyContent="center">
        <AlertInfo text={textAlertInfo} open={openAlertInfo} onDoneClick={() => setOpenAlertInfo(false)} />
        <GridItem xs={12} sm={6} md={4}>
          {ingresoSistemaState?.isActivityIndicatorShown && <WaitDialog text="Validando datos..." />}
          <form>
            <Card login className={classes[cardAnimaton]}>
              <CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color="success">
                <h4 className={classes.cardTitle}>
                  <img src={logo} alt="..." width="140" />
                </h4>
                <h3>App Ciudadana</h3>
              </CardHeader>
              <CardBody>
                <GoogleOAuthProvider clientId={clientId}>
                  <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
                </GoogleOAuthProvider>
              </CardBody>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
      <Dialog
        open={openModalRegistro}
        onClose={() => setOpenModalRegistro(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            zIndex: 3001,
            position: 'relative',
            padding: '2rem',
          },
        }}
        BackdropProps={{
          style: {
            zIndex: 3000
          }
        }}
      >
        <FormularioRegistroUsuario
          googleData={datosGoogle}
          onClose={() => setOpenModalRegistro(false)}
          onSubmit={handleRegistroUsuario}
          tiposIdentificacion={tiposIdentificacionList.documentos}
        />
      </Dialog>
    </div>

  );
};

IngresoSistema.propTypes = {
  classes: PropTypes.object.isRequired,
  ingresoSistemaState: PropTypes.object,
  ingresoInicioSolicitud: PropTypes.func.isRequired,
  ingresoCompletarSolicitud: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  ingresoSistemaState: state.ingresoSistemaState,
});

const mapDispatchToProps = {
  addMessage,
  ingresoInicioSolicitud,
  ingresoCompletarSolicitud,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(IngresoSistema));
